export default __webpack_public_path__ + "static/media/scrivener.11307d91.jpg";